"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FilterStatus;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _checkbox = _interopRequireDefault(require("@ux/checkbox"));
var _react2 = require("@linaria/react");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
const StatusListContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "StatusListContainer",
  class: "pl-s86qhog"
});
function FilterStatus({
  statusList,
  statusCounts,
  handleStatusSelection,
  checkboxProps
}) {
  return /*#__PURE__*/_react.default.createElement(StatusListContainer, {
    "data-cy": "status-list-container"
  }, statusList && statusList.map(({
    id,
    statusLabel,
    checked,
    value
  }) => {
    return /*#__PURE__*/_react.default.createElement(_checkbox.default, (0, _extends2.default)({
      key: `status-${id}`,
      id: `status-${id}`,
      "data-cy": `status-item`,
      name: statusLabel,
      label: `${statusLabel} (${statusCounts[id]})`,
      onChange: handleStatusSelection(id),
      checked,
      value
    }, checkboxProps));
  }));
}
FilterStatus.propTypes = {
  handleStatusSelection: _propTypes.default.func,
  statusCounts: _propTypes.default.object,
  statusList: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.number,
    name: _propTypes.default.string,
    label: _propTypes.default.string,
    checked: _propTypes.default.bool,
    text: _propTypes.default.string
  })),
  checkboxProps: _propTypes.default.shape(_checkbox.default.propTypes)
};